import { render, staticRenderFns } from "./tf.vue?vue&type=template&id=707a7504&"
import script from "./tf.vue?vue&type=script&lang=js&"
export * from "./tf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports